// extracted by mini-css-extract-plugin
export default {"divStyle":"Skeleton__divStyle__GB5kD","shimmer":"Skeleton__shimmer__Q6qSS"};
    if(module.hot) {
      // 1763020726967
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  